import React from 'react';
import { useDispatch } from "react-redux";
import {Link, useNavigate} from 'react-router-dom';

import Swal from 'sweetalert2';
import {Dropdown} from 'react-bootstrap';

import Avatar from 'components/common/Avatar';

import { logout } from 'store/slices/authentication';
import { certificationActions } from 'store/slices/certification/certificationSilce';

import userIcon from 'assets/img/icons/user.png';


const ProfileDropdown = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch();

	
	const handleLogout = () => {
        Swal.fire({
			title: `¿Estás seguro?`,
			text: "¿Quieres cerrar sesión?",
			icon: "warning",
			confirmButtonText: 'Sí, cerrar sesión',
			cancelButtonText: 'Cancelar',
			showCancelButton: true,
			showCloseButton: true,
			allowOutsideClick: false,
			allowEscapeKey: false,
			allowEnterKey: false,
			reverseButtons : true
		}).then((result) => {
			if (result.isConfirmed) {	
				console.log("Cerrando sesión...");
				dispatch(logout());
				dispatch(certificationActions.resetCertification());
              	navigate("pages/login");
			}
		}).catch(() => {
			return false;
		})
    };

	return (
		<Dropdown navbar={true} as="li">
			<Dropdown.Toggle bsPrefix="toggle"
				as={Link}
				to="#!"
				className="pe-0 ps-2 nav-link">
				<Avatar src={userIcon}/>
			</Dropdown.Toggle>

			<Dropdown.Menu className="dropdown-caret dropdown-menu-card  dropdown-menu-end">
				<div className="bg-white rounded-2 py-2 dark__bg-1000">
					{/* 
						<Dropdown.Item className="fw-bold text-warning" href="#!">
							<FontAwesomeIcon icon="crown" className="me-1" />
							<span>Go Pro</span>
						</Dropdown.Item>
						<Dropdown.Divider />
						<Dropdown.Item href="#!">Set status</Dropdown.Item>
						<Dropdown.Item as={Link} to="/user/profile">
							Profile &amp; account
						</Dropdown.Item>
						<Dropdown.Item href="#!">Feedback</Dropdown.Item>
						<Dropdown.Divider />
						<Dropdown.Item as={Link} to="/user/settings">
							Settings
						</Dropdown.Item> 
					*/}
					<Dropdown.Item onClick={handleLogout}>
						Salir
					</Dropdown.Item>
				</div>
			</Dropdown.Menu>
		</Dropdown>
	);
};

export default ProfileDropdown;
